import { Fragment, type ReactNode } from 'react';

function inline(text: string): ReactNode {
  return text.split(/(`[^`]+`)/u).map((part, index) =>
    part.startsWith('`') && part.endsWith('`') ? (
      <code key={`${part}-${String(index)}`} className="rounded bg-muted px-1 py-0.5 text-[0.9em]">
        {part.slice(1, -1)}
      </code>
    ) : (
      <Fragment key={`${part}-${String(index)}`}>{part}</Fragment>
    ),
  );
}

export function HelpMarkdown({ body }: { readonly body: string }): JSX.Element {
  const blocks = body.split(/\n\s*\n/u);
  return (
    <article className="space-y-4 text-sm leading-6 [overflow-wrap:anywhere] [hyphens:auto]">
      {blocks.map((block) => {
        const heading = /^(#{1,3})\s+(.+?)\s+\{#([a-z0-9-]+)\}$/u.exec(block);
        if (heading !== null) {
          const marker = heading[1] ?? '';
          const label = heading[2] ?? '';
          const anchor = heading[3] ?? '';
          const level = marker.length;
          const className =
            level === 1 ? 'text-xl font-semibold' : 'scroll-mt-20 text-base font-semibold';
          if (level === 1)
            return (
              <h1 key={anchor} id={anchor} className={className}>
                {inline(label)}
              </h1>
            );
          return (
            <h2 key={anchor} id={anchor} className={className}>
              {inline(label)}
            </h2>
          );
        }
        return <p key={block}>{inline(block.replaceAll('\n', ' '))}</p>;
      })}
    </article>
  );
}
